import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers } from './app.reducer';
import { DashboardingStoreEffects } from './dashboarding/dashboarding.effects';

@NgModule({
    imports: [
        StoreModule.forRoot(reducers, {
            runtimeChecks: {
                strictStateImmutability: true
            }
        }),
        EffectsModule.forRoot([DashboardingStoreEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 50
        })
    ],
    exports: [StoreModule, EffectsModule],
    declarations: [],
    providers: []
})
export class AppStoreModule {}
